import {
  AvailableFilters, PickedFilters, ReadsModeType,
  IntervalFullType, AggregatedReadsData, AggregatedAlertsData,
  AlertsModeType,
} from './Charts.types';

export const intervals = ['1h', '1d', '7d', '1w', '30d'];

export const initFilt = {
  duration: '28d',
  site: '',
  cameras: [],
  alerts: [],
  type: 'all',
  fromDate: '',
  toDate: '',
} as PickedFilters;

export const initAvailableFilters = {
  duration: [
    {
      name: 'Last 7 days',
      value: '7d',
    },
    {
      name: 'Last 28 days',
      value: '28d',
    },
    {
      name: 'Last 90 days',
      value: '90d',
    },
  ],
  site: [],
  cameras: [],
  alerts: [],
  type: [
    {
      name: 'All',
      value: 'all',
    },
    {
      name: 'Alerts',
      value: 'alerts',
    },
    {
      name: 'Reads',
      value: 'reads',
    },
  ],
} as AvailableFilters;

export const readsResultInit = {
  camerasData: [],
  sitesData: [],
  heatmapData: [],
} as AggregatedReadsData;

export const alertsResultInit = {
  ...readsResultInit,
  alertsData: [],
} as AggregatedAlertsData;

export const availableReadsMode = [
  {
    value: 'site',
    name: 'By Site',
  },
  {
    value: 'camera',
    name: 'By Camera',
  },
] as ReadsModeType[];

export const availableAlertsMode = [
  {
    value: 'site',
    name: 'By Site',
  },
  {
    value: 'camera',
    name: 'By Camera',
  },
  {
    value: 'alert',
    name: 'By Alert Class',
  },
] as AlertsModeType[];

export const availableIntervals = [
  {
    name: 'Hourly',
    value: '1h',
    dateFormat: 'MM Do YY, h a',
  },
  {
    name: 'Daily',
    value: '1d',
    dateFormat: 'MMM Do, YY',
  },
  {
    name: 'Weekly',
    value: '1w',
    dateFormat: 'MMM Do, YY',
  },
  {
    name: 'Monthly',
    value: '30d',
    dateFormat: 'MMM Do, YY',
  },
] as IntervalFullType[];

export const initDataForShare = {
  graph: false,
  table: false,
  map: false,
};
